import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { ZefTranslationsService } from '@zerops/zef/translations';
import { FEATURE_NAME } from './addon-activation-dialog.constant';

const en = {
  close: 'Close',
  activateTitle: 'Activate unique IPv4 address',
  reuseTitle: 'Reuse paid IPv4 address',
  releaseTitle: 'Release unique IPv4 address',
  projectPrefix: 'Project',
  activateDesc: 'gets a unique IPv4 address for direct port routing with a firewall, without the limits of the shared IPv4 address.',
  reuseDesc: 'gets a unique IPv4 address for the period you already paid for. The address may differ from the released one.',
  releaseDesc: 'The IPv4 address is removed from project',
  releaseDescSuffix: 'immediately.',
  releaseReuseDesc: 'Until {{validTill}}, the paid period is reused at no extra charge when you request a unique IPv4 address on any project.',
  releaseIpV4: 'Release IPv4 address',
  creditWarning: 'You do not have enough credit to purchase the add-on'
};

export type AddonActivationDialogTranslations = typeof en;

@NgModule({ exports: [ TranslocoModule ] })
export class AddonActivationDialogTranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
